import { render, staticRenderFns } from "./DeleteCollectionBtnDialog.vue?vue&type=template&id=32eeff0e&scoped=true"
import script from "./DeleteCollectionBtnDialog.vue?vue&type=script&lang=js"
export * from "./DeleteCollectionBtnDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32eeff0e",
  null
  
)

export default component.exports